<section class="names o-page">
	<h1
		class="c-page-heading o-page__heading"
		data-quat="value_namesHeading"
	>Add a Vet Clinic for {{ petName$ | async }}</h1>
	<form
		[formGroup]="nameForm"
		class="names__form o-page__content"
	>
		<section class="c-radio-group">
			<p
				id="otherNamesDescription"
				class="c-radio-group__description"
			>
				<span
					class="c-radio-group__description-heading"
					data-quat="names_subheading"
				> Has {{ petName$ | async }} gone by any other names at {{ clinicName$ | async }}? </span>
				<span class="c-radio-group__description-subheading"> This includes while in your care or before you
					adopted them. </span>
			</p>
			<div
				role="presentation"
				class="c-radio-group__controls"
			>
				<mat-radio-group
					formControlName="hasOtherNames"
					class="names__radio-group"
					aria-labelledby="otherNamesDescription"
				>
					<mat-radio-button
						[disableRipple]="true"
						[value]="true"
						data-quat="input_otherNamesYes"
					>Yes</mat-radio-button>
					<mat-radio-button
						[disableRipple]="true"
						[value]="false"
						data-quat="input_otherNamesNo"
					>No</mat-radio-button>
				</mat-radio-group>
			</div>
		</section>
		<div
			[hidden]="hideNameInput"
			role="presentation"
			class="c-input-group names__group-names"
		>
			<label
				for="otherNames"
				class="c-input-group__label"
				data-quat="label_namesList"
			> List any other pet names </label>
			<input
				formControlName="otherNames"
				type="text"
				name="otherNames"
				id="otherNames"
				class="c-input-group__input names__input-names"
				maxlength="100"
				data-quat="input_namesList"
			>
		</div>
		<button
			[disabled]="nameForm.invalid"
			class="c-cta names__cta"
			type="button"
			data-quat="action_nextStep"
			(click)="nextStep()"
		>Next</button>
	</form>
	<section class="c-workflow-actions o-page__actions">
		<mv-back-button
			class="c-workflow-actions__item m--start"
			(click)="stepBack()"
		></mv-back-button>
		<mv-cancel-button
			class="c-workflow-actions__item m--end"
			(click)="cancel()"
		></mv-cancel-button>
	</section>
</section>